import { type JSX } from "react";
import { AnimatePresence, motion } from "framer-motion";

interface FadeProps {
  children: React.ReactNode;
  className?: string;
  stateKey?: string | number;
  transitionDuration?: number;
}

export const Fade = (props: FadeProps): JSX.Element => {
  const { children, className, stateKey, transitionDuration = 0.2 } = props;

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={stateKey}
        className={className}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: transitionDuration }}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
};
